import React, { useCallback, useEffect, useState } from 'react'
import { BookingMeetingRoomApi, getRoomMeetingByTypeList } from '../../../../api/booking-meeting-room/booking-meeting-room.api'
import { Box, Button, Card, CardContent, CardMedia, Grid, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { ROOM_MEETING_FILE_TYPE } from '../../../../constants/enum';
import { ImageContent } from '../../../../assets/background/background';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ModalCustom from '../../../../components/modal/modalCustomCms';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SwiperCustom from '../../../../components/swiper/SwiperCustom';
import StepperCustom from '../../../../components/step/Stepper';
import ArticleIcon from '@mui/icons-material/Article';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BookingCalendarLegacy from './CalendarActivity';
import { useTranslation } from 'react-i18next';

type Props = {
    room_meeting_type: string;
    selectedId: number | null;
    setSelectedId: React.Dispatch<React.SetStateAction<number | null>>;
    id_room_meeting?: number;
    view?: boolean;
    is_personal?: boolean;
}
type RoomData = {
    id: number;
    name: string;
    room_meeting_location: string;
    capacity: number;
    price_thb: number;
    price_usd: number;
    image: string;
};


const ListClassrooms = ({ room_meeting_type, selectedId, view, id_room_meeting, setSelectedId }: Props) => {

    const { t } = useTranslation();
    const [rooms, set_rooms] = useState<any[]>([]);
    const base_url_image = useSelector((state: RootState) => state.api.image_api);

    const [detail, set_detail] = useState<any>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [step, set_step] = useState<number>(0);

    const handleCloseModal = () => {
        setShowModal(false);
        set_detail(null);
        set_step(0);
    }

    const handleGetData = useCallback(async () => {
        let query: getRoomMeetingByTypeList = {
            room_meeting_type: room_meeting_type
        }
        await BookingMeetingRoomApi.getRoomMeetingByTypeList(query).then((res) => {
            if (res.status < 300) {
                const response: any[] = res.data?.data || [];
                const mapData: RoomData[] = response?.length > 0 ? response?.map((list) => {
                    const file_list: any[] = list?.files || [];
                    const cover_file = file_list?.find((x) => x?.room_meeting_file_type === ROOM_MEETING_FILE_TYPE.COVER)?.file_path;
                    return {
                        capacity: list?.room_meeting_amount || 0,
                        id: list?.id_room_meeting,
                        room_meeting_location: list?.room_meeting_location || "",
                        image: cover_file ? base_url_image + cover_file : ImageContent.noImage,
                        name: list?.room_meeting_name || "",
                        price_thb: list?.internal_service_fees ? Number(list?.internal_service_fees) : 0,
                        price_usd: list?.external_service_fees ? Number(list?.external_service_fees) : 0,
                    }
                }) : []
                set_rooms(mapData);
            }
        })
    }, [room_meeting_type]);

    const handleGetDetailData = async (id_room_meeting: number) => {
        await BookingMeetingRoomApi.getRoomMeetingDetailById(id_room_meeting).then((res) => {
            if (res.status < 300) {
                setShowModal(true);
                const response = res.data?.data || null;
                set_detail(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }


    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return (
        <Box my={4} >
            <Grid container spacing={2}>
                {rooms.map((room) => (
                    <Grid item xs={12} sm={6} md={3} key={room.id}>
                        <Card
                            sx={{
                                borderRadius: 3,
                                boxShadow: 3,
                                overflow: "hidden",
                                position: "relative",
                            }}
                        >
                            <Box
                                className="w-full overflow-hidden"
                                sx={{ height: 270, maxHeight: 270 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={room.image}
                                    alt={room.name}
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                        display: "block",
                                    }}
                                />
                                <RemoveRedEyeIcon
                                    sx={{ position: "absolute", top: 5, right: 5, color: "white" }}
                                    onClick={() => handleGetDetailData(room?.id)}
                                    className="cursor-pointer"
                                />
                            </Box>
                            <CardContent>
                                <Typography fontWeight={600}>{room.name}</Typography>
                                <Stack spacing={0.5} mt={1}>
                                    <Typography variant="body2">
                                        <LocationOnIcon /> {room?.room_meeting_location}
                                    </Typography>
                                    <Typography variant="body2">👥 {t("{{amount}} คน", { amount: room.capacity })}</Typography>
                                    <Typography variant="body2">
                                        {t("ค่าบริการ : {{thb}}฿ / วัน หรือ {{usd}} USD / วัน", { thb: room.price_thb.toLocaleString(), usd: room.price_usd.toLocaleString() })}
                                    </Typography>
                                </Stack>
                            </CardContent>
                            <Box p={2} pt={0}>
                                <Button
                                    fullWidth
                                    disabled={view}
                                    variant={selectedId === room.id ? "contained" : "outlined"}
                                    color={selectedId === room.id ? "error" : "inherit"}
                                    onClick={() =>
                                        setSelectedId(selectedId === room.id ? null : room.id)
                                    }
                                >
                                    {selectedId === room.id ? t("ยกเลิก") : t("เลือก")}
                                </Button>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {showModal && (
                <ModalCustom
                    handleClose={handleCloseModal}
                    onClick={() => { }}
                    open
                    title={t("รายละเอียด {{name}}", { name: detail?.room_meeting_name })}
                    subTitle={`📍 ${detail?.room_meeting_location || ""} 🧍🏼 ${t("{{amount}} คน", { amount: detail?.room_meeting_amount || "-" })}`}
                    maxWidth='sm'
                    scrollBody
                    hintSubmitButton
                    cancelButtonName={t("ย้อนกลับ")}
                    form={
                        <Box className="w-full">
                            <Box className="m-auto max-w-[380px]">
                                <StepperCustom
                                    sx={{ maxWidth: 'fit-content' }}
                                    step={step}
                                    setStep={set_step}
                                    view
                                    stepLabel={[
                                        {
                                            name: t("ข้อมูลห้อง"),
                                            isAccept: true,
                                            icon: <ArticleIcon />,
                                            disabled: false
                                        },
                                        {
                                            name: t("ข้อมูลการจอง"),
                                            isAccept: true,
                                            icon: <CalendarMonthIcon />,
                                            disabled: false
                                        },
                                    ]}
                                />
                            </Box>
                            {step === 0 && (
                                <>
                                    <SwiperCustom
                                        data={detail?.files?.map((list: any) => {
                                            const img_path = base_url_image + list?.file_path;
                                            return {
                                                content: (
                                                    <Box className="w-full flex justify-center items-center">
                                                        <img
                                                            src={img_path}
                                                            alt={list?.file_name}
                                                        />
                                                    </Box>
                                                )
                                            }
                                        })}
                                    />
                                    <Box my={2}>
                                        <Typography variant='h6'>{t("อุปกรณ์ภายในห้อง")}</Typography>
                                        <ul className="list-disc pl-6 pt-4">
                                            {detail?.equipment?.length > 0 &&
                                                detail.equipment.map((list: any, i: number) => (
                                                    <li key={i + 1}>
                                                        {`${list?.equipment_name || ""} ${list?.qty || ""} ${list?.equipment_unit || ""}`}
                                                    </li>
                                                ))}
                                        </ul>
                                    </Box>
                                </>
                            )}

                            {step === 1 && (
                                <Box className="w-full">
                                    <BookingCalendarLegacy
                                        id_room_meeting={id_room_meeting}
                                    />
                                </Box>
                            )}
                        </Box>
                    }
                />
            )}
        </Box>
    )
}

export default ListClassrooms